import {PosInitData} from 'tplus-poslogin';

/**
 * 获取某个菜单是否有权限
 */

export class AuthProcess {
    static execute(name) {
        let operations = PosInitData('FunctionAuth');
        //console.log('membermenu-operations',operations)
        if (operations) {
            for (let index = 0; index < operations.length; index++) {
                const operation = operations[index];
                if ((name + '') == (operation + '')) {
                    return true;
                }
            }
        }
        return false
    }
}